import { createEntityAdapter } from '@ngrx/entity';
const ɵ0 = (e) => e.slug;
export const invoicesAdapter = createEntityAdapter({
    selectId: ɵ0,
    sortComparer: false
});
export const invoicesInitialState = invoicesAdapter.getInitialState({
    isLoading: true,
    error: null
});
export const selectIsLoading = (state) => state.isLoading;
export const selectError = (state) => state.error;
export { ɵ0 };
